import { useContext } from "react"
import { PusherContext } from "../components/pusherContext"

const usePusherContext = () => {
  const context = useContext(PusherContext);
  return context
}

export { usePusherContext }
